import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from './api-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeyValuePair } from '@morningstar/shared/models';
import { tap } from 'rxjs/operators';

export abstract class TableService<T> extends ApiService<T> {

  private tableData = new BehaviorSubject<T[]>([]);
  public tableData$ = this.tableData.asObservable();

  constructor(protected snackbar: MatSnackBar,
              protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl: string) {
    super(httpClient, baseUrl, snackbar);
  }

  setTableData(tableData) {
    this.tableData.next(tableData);
  }

  getList(endpoint: string, params?: KeyValuePair[]): Observable<T[]> {
    return super.getList(endpoint, params).pipe(
      tap(data => this.setTableData(data))
    );
  }
}
